const poolData = {
  UserPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
  ClientSecretKey: process.env.VUE_APP_COGNITO_CLIENT_SECRET_KEY,
  IdentityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
  region: process.env.VUE_APP_COGNITO_REGION,
};

export default { poolData };
